import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { text } from "@/constants/tailwind-theme";

const ServiceItemComponent = ({
  type = "primary",
  title,
  description,
  icon,
}) => {
  const isSecondary = type === "secondary";

  return (
    <Card
      className={cn(
        "h-full border-none transition-shadow hover:shadow-md",
        isSecondary ? "bg-white" : "bg-primary-500 text-white"
      )}
    >
      <CardHeader className="items-center text-center">
        <img className="mb-2 h-20 w-20" src={icon} alt="" />
        <CardTitle
          className={cn(
            text.heading2,
            "text-center",
            isSecondary ? "text-primary-500" : "text-white"
          )}
        >
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p
          className={cn(
            text.body1,
            "text-center",
            isSecondary ? "text-primary-500" : "text-white/90"
          )}
        >
          {description}
        </p>
      </CardContent>
    </Card>
  );
};

export default ServiceItemComponent;
